/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import annexBFourByteStartCode from '../../../decode/bitstream/codec/h264/nalUnit/AnnexBFourByteStartCode';

export default new Uint8Array([
  ...annexBFourByteStartCode, 6, 3, 255, 61, ...new Uint8Array(316).fill(255), 128,
  ...annexBFourByteStartCode, 65, 154, 32, 26, 240, 18, 48
]);